<template>
  <div v-if="event">
    <b-container fluid>
      <b-row>
        <b-col>
          <h2>Configurações da Loja</h2>
          <h3 class="my-3">Operação: {{ event.name }}</h3>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-form-group label="Loja Virtual:">
            <toggle-button
              :value="event.virtual_store === 1"
              :sync="true" :width="45" :height="25"
              :color="{checked: '#337ab7', unchecked: '#cccccc'}"
              @change="switchVirtualStore"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group label="Ocultar Loja Virtual:">
            <toggle-button
              :value="event.hidden_store === 1"
              :sync="true" :width="45" :height="25"
              :color="{checked: '#F39C12', unchecked: '#cccccc'}"
              @change="switchHiddenStore"
              :disabled="event.virtual_store === 0"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group label="Cupom de Desconto:">
            <toggle-button
              :value="event.coupon_discount_enabled === 1"
              :sync="true" :width="45" :height="25"
              :color="{checked: '#28a745', unchecked: '#cccccc'}"
              @change="toggleCouponDiscount"
              :disabled="event.virtual_store === 0"
            />
            <small class="form-text text-muted">
              Exibe menu de cupons e colunas de desconto para o organizador.
            </small>
          </b-form-group>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import ToggleButton from 'vue-js-toggle-button/src/Button'

export default {
  name: 'AdminStoreConfig',
  components: {
    ToggleButton
  },
  data () {
    return {
      event: null,
      eventAttribute: null
    }
  },
  async mounted () {
    await this.getEvent()
  },
  methods: {
    async getEvent () {
      try {
        const eventId = this.$route.params.id
        const url = process.env.VUE_APP_URL_APP + `/b/events/${eventId}`
        const resp = await this.$http.get(url)
        this.event = resp.body
        this.event.hidden_store = this.event.hidden_store || 0
        this.event.coupon_discount_enabled = this.event.coupon_discount_enabled || 0
      } catch (error) {
        console.error(error)
      }
    },
    async switchVirtualStore () {
      const state = this.event.virtual_store
      let url = process.env.VUE_APP_URL_APP + `/b/events/${this.event.id}/stores`
      
      if (state === 0) {
        url += '/enable'
      } else if (state === 1) {
        url += '/disable'
      }

      try {
        await this.$http.put(url, {})
        if (state === 0) {
          this.event.virtual_store = 1
        } else if (state === 1) {
          this.event.virtual_store = 0
          await this.disableHiddenStore()
          await this.disableCouponDiscount()
        }
      } catch (err) {
        alert(err.body.message)
        console.log(err)
      }
    },
    async disableHiddenStore () {
      if (this.event.hidden_store === 0) {
        return
      }

      const url = process.env.VUE_APP_URL_APP + `/b/events/${this.event.id}/stores/hidden/disable`

      try {
        await this.$http.put(url, {})
        this.event.hidden_store = 0
      } catch (err) {
        this.event.hidden_store = 0
      }
    },
    async switchHiddenStore () {
      const state = this.event.hidden_store
      let url = process.env.VUE_APP_URL_APP + `/b/events/${this.event.id}/stores/hidden`

      if (state === 0) {
        url += '/enable'
      } else if (state === 1) {
        url += '/disable'
      }

      try {
        await this.$http.put(url, {})
        if (state === 0) {
          this.event.hidden_store = 1
        } else if (state === 1) {
          this.event.hidden_store = 0
        }
      } catch (err) {
        alert(err.body.message)
        console.log(err)
      }
    },
    async disableCouponDiscount () {
      if (this.event.coupon_discount_enabled === 0) {
        return
      }

      const url = process.env.VUE_APP_URL_APP + `/b/events/${this.event.id}/stores/coupon-discount/toggle`

      try {
        await this.$http.put(url, {})
        this.event.coupon_discount_enabled = 0
      } catch (err) {
        this.event.coupon_discount_enabled = 0
      }
    },
    async toggleCouponDiscount () {
      const url = process.env.VUE_APP_URL_APP + `/b/events/${this.event.id}/stores/coupon-discount/toggle`

      try {
        await this.$http.put(url, {})
        this.event.coupon_discount_enabled = this.event.coupon_discount_enabled === 1 ? 0 : 1
      } catch (err) {
        alert(err.body.message)
        console.log(err)
      }
    }
  }
}
</script>


